class FlagCorrectionService {
  constructor(csrfToken) {
    this.csrfToken = csrfToken;
  }

  flagCorrection(chatMessageId, reason = '') {
    return fetch('/langua/correction_flag', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken
      },
      credentials: 'same-origin',
      body: JSON.stringify({ chat_message_id: chatMessageId, reason })
    }).then(response => response.json());
  }
}

export default FlagCorrectionService;
